module.exports = __webpack_public_path__ + "static/media/mask_3.ad6f9a3a.svg";